import React, { useState, useEffect, useContext, useMemo } from "react";

import PropTypes from "prop-types";
import axios from "axios";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import UseChartsListCall from "./UseChartsListCall";

import Button from "components/CustomButtons/Button.js";
import UserService from "../../services/UserService";

import { makeStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

import AddDashboard from "./AddDashboard";
import EditButton from "components/CustomButtons/Button.js";
import CustomDeleteButton from "../CustomDeleteButton/CustomDeleteButton.js";
import { vuepagetext } from "variables/vues";
import DataTable from "react-data-table-component";
import EditIcon from "@mui/icons-material/Edit";
import styled from "styled-components";
import LinearProgress from "@mui/material/LinearProgress";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import uuid from "react-uuid";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";

import CategoryEditionDialog from "./CategoryEditionDialog";
import AddIcon from "@mui/icons-material/Add";

import {
  getUsers,
  postDashboard,
  getDashboard,
  deleteDashboard,
} from "../../services/ConfigServices";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "assets/css/customNotifications.css";
import { selectDateOptions } from "components/Analyses/DatesOptions";

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;
const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles2 = makeStyles(styles);
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  card: {
    marginLeft: "0.5rem",
    width: "8rem",
    height: "6rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    border: "0.17rem solid",
    borderColor: "rgba(62, 180, 98, 0.6)",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  cardAction: {
    width: "8rem",
    height: "6rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
    textTransform: "none",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontWeight: "600",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "0rem 0rem 0rem",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: "14px",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-root": {
      height: "45px",
    },
    "& .MuiInputBase-multiline": {
      height: "auto",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 13px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .Mui-disabled": {
      color: "#000000",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
    },
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: "14px",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: "14px",
  },
  switch: {
    marginLeft: "0.5rem",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  icon: {
    width: "5rem",
    height: "5rem",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
}));

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      style={{ width: "100%" }}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const permis = JSON.parse(localStorage.getItem("permission")) || [];
const view_create = permis.includes("view_create");
const view_update = permis.includes("view_update");

function TabDetail(props) {
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [groupid, setGroupid] = useState(2151);
  const [details, setDetails] = useState(null);
  const [data, setData] = useState([]);
  const [currentCategory, setCurrentCategory] = useState(null);
  const [open, setOpen] = useState(false);
  const [modification, setModification] = useState(false);

  const handleNameChange = (event) => {
    setName(event.target.value);
    setModification(true);
  };
  const handleDelete = async (event) => {
    let viewid = id;
    axios
      .delete(deleteDashboard(viewid), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Dashboard supprimé");
        } else {
          NotificationManager.error("Une erreur est survenue");
        }
        props.fetchData();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const handleEdit = async (event) => {
    const editedDashboard = [...data];
    axios
      .put(
        postDashboard(),
        {
          id,
          name,
          details: {
            AnalysePage: editedDashboard,
            MapsPage: {},
          },
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Dashboard modifié");
          setModification(false);
        } else {
          NotificationManager.error("Une erreur est survenue");
        }
        props.fetchData();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };
  //console.log(analysePages);

  const { chartsList, selectedCharts, setSelectedCharts } = UseChartsListCall();

  useEffect(() => {
    axios
      .get(getDashboard(props.id), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setName(res.data.name);
        setGroupid(res.data.groupid);
        setId(res.data.id);
        setDetails(res.data.details);
        let tmpdata = res.data.details.AnalysePage;
        let position = 1;
        tmpdata.forEach((category) => {
          if (!category.uuid) {
            category.uuid = uuid();
          }
          if (!category.position) {
            category.position = position;
            position++;
          }
        });
        setData(tmpdata);
      });
  }, []);

  const deleteCategoryFunction = (row) => async () => {
    let obj = data.find((o) => o.uuid === row.uuid);
    if (obj) {
      let newcategories = [...data];
      newcategories.forEach((category) => {
        if (category.position > obj.position) {
          category.position = category.position - 1;
        }
      });
      newcategories = data.filter((o) => o.uuid !== row.uuid);
      setData(newcategories);
      setModification(true);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    if (!currentCategory.name)
      currentCategory.name = 'Nouvelle catégorie';
    setOpen(false);
  };

  const AddCategory = () => {
    let newCategory = {
      uuid: uuid(),
      name: 'Nouvelle catégorie',
      views: [],
      position: data.length + 1,
    };
    let tmpdata = [...data];
    tmpdata.push(newCategory);
    setData(tmpdata);
    setCurrentCategory(newCategory);
    setModification(true);
    handleClickOpen();
  };

  const editCategory = (row) => async () => {
    let obj = data.find((o) => o.uuid === row.uuid);
    if (obj) {
      setCurrentCategory(obj);
      handleClickOpen();
    }
  };

  const upCategory = (row) => async () => {
    let newcategories = [...data];
    let obj = newcategories.find((o) => o.uuid === row.uuid);
    let oldposition = obj.position;
    let newposition = oldposition - 1; //ie 3 -> 2
    let replacedchart = newcategories.find((o) => o.position === newposition);
    obj.position = newposition;
    replacedchart.position = oldposition;
    setData(newcategories);
    setModification(true);
  };

  const downCategory = (row) => async () => {
    let newcategories = [...data];
    let obj = newcategories.find((o) => o.uuid === row.uuid);
    let oldposition = obj.position;
    let newposition = oldposition + 1; //ie 3 -> 4
    let replacedchart = newcategories.find((o) => o.position === newposition);
    obj.position = newposition;
    replacedchart.position = oldposition;
    setData(newcategories);
    setModification(true);
  };


  const classes = useStyles();
  const classes2 = useStyles2();

  const columns = [
    {
      name: vuepagetext.position,
      selector: (row) => row.position,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.position || ""
    },
    {
      name: vuepagetext.categoryname,
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => row.name,
    },
    {
      name: vuepagetext.vuescount,
      selector: (row) => row.name,
      sortable: false,
      maxWidth: "12rem",
      cell: (row) => row.views?.length || "0"
    },
    {
      name: "",
      sortable: false,
      width: "12rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            {view_create && (
              <>
                <Tooltip title="Monter la position">
                  <EditButton
                    onClick={upCategory(row)}
                    color={"info"}
                    className={classes2.actionButton}
                    disabled={row.position == 1}
                  >
                    <ArrowDropUpIcon fontSize="large" />
                  </EditButton>
                </Tooltip>
                <Tooltip title="Descendre la position">
                  <EditButton
                    onClick={downCategory(row)}
                    color={"info"}
                    className={classes2.actionButton}
                    disabled={row.position == data.length}
                  >
                    <ArrowDropDownIcon fontSize="large" />
                  </EditButton>
                </Tooltip>
                <Tooltip title={vuepagetext.editcategory}>
                  <EditButton
                    onClick={editCategory(row)}
                    color={"warning"}
                    className={classes2.actionButton}
                  >
                    <EditIcon fontSize="large" />
                  </EditButton>
                </Tooltip>
                <Tooltip title={vuepagetext.delcategory}>
                  <CustomDeleteButton
                    deleteTitle={"Suppression de la catégorie"}
                    deleteSubTitle={`Êtes-vous sûr de vouloir supprimer la catégorie ${row.name}?`}
                    handleSupprimer={deleteCategoryFunction(row)}
                  />
                </Tooltip>
              </>
            )}
          </div>
        </>
      ),
    },
  ];

  const [filterTextChart, setFilterTextChart] = useState("");
  const [resetPaginationToggleChart, setResetPaginationToggleChart] = useState(false);
  const SearchComponentChart = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = data.filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterTextChart.toLowerCase()))
  );
  const subHeaderComponentMemoChart = useMemo(() => {
    const handleClearChart = () => {
      if (filterTextChart) {
        setResetPaginationToggleChart(!resetPaginationToggleChart);
        setFilterTextChart("");
      }
    };
    const onFilterTextChart = (e) => setFilterTextChart(e.target.value);

    return (
      <>
        <TableName>Catégories du dashboard</TableName>
        <SearchComponentChart
          key="SearchComponentChart"
          onFilter={onFilterTextChart}
          onClear={handleClearChart}
          filterText={filterTextChart}
        />
        {view_create && (
          <>
            <UploadButton type="button" onClick={handleClearChart}>
              <Tooltip title="Ajouter une catégorie">
                <Button
                  onClick={AddCategory}
                  color={"success"}
                  className={classes2.actionButton}
                >
                  <AddIcon fontSize="large" />
                </Button>
              </Tooltip>
            </UploadButton>
          </>
        )}
      </>
    );
  }, [filterTextChart, resetPaginationToggleChart, data]);

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <div className={classes.input}>
              <div className={classes.inputTitle}>Nom du dashboard</div>
              <TextField
                required
                variant="outlined"
                id="permissionName-required-outlined-size-small"
                label=""
                style={{
                  maxWidth: "50%",
                  margin: "2px 8px",
                  fontFamily: '"Source Sans Pro",sans-serif',
                  fontSize: "14px",
                }}
                value={name}
                onChange={handleNameChange}
                className={classes.textField}
              />
            </div>
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <DataTable
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            noDataComponent={<NoData>Aucune catégorie à afficher</NoData>}
            noHeader={true}
            columns={columns}
            persistTableHead
            pagination
            subHeader
            data={filteredItems}
            paginationComponentOptions={{
              noRowsPerPage: false,
              rowsPerPageText: "Lignes par page",
              rangeSeparatorText: "sur",
              selectAllRowsItem: false,
              selectAllRowsItemText: "Selectionner toutes les lignes",
            }}
            defaultPageSize={10}
            filterable={true}
            defaultSortFieldId={1}
            manual={true}
            paginationResetDefaultPage={setResetPaginationToggleChart}
            subHeaderComponent={subHeaderComponentMemoChart}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "2.5rem",
              marginLeft: "0.2rem",
              marginRight: "auto",
            }}
          >
            <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: modification ? "#91C73C" : "#9798A0",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "13px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              disabled={!modification}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button>
            {permis.includes("view_create") ? (
              <CustomDeleteButton
                size="40px"
                deleteTitle={"Suppression du dashboard"}
                deleteSubTitle={
                  "Êtes-vous sûr de vouloir supprimer le dashboard?"
                }
                handleSupprimer={handleDelete}
              >
                Supprimer
              </CustomDeleteButton>
            ) : (
              <></>
            )}
          </div>
        </GridItem>
      </GridContainer>
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open}
      >
        <CategoryEditionDialog
          currentCategory={currentCategory}
          closeModal={handleEditClose}
          chartsList={chartsList}
          setModification={setModification}
        />
      </Dialog>
    </div>
  );
}

export default function Vues() {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, setPage } = appContext;

  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [dashboardList, setDashboardList] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleNewDashboard = () => {
    axios
      .post(
        postDashboard(),
        {
          name: "Nouveau Dashboard",
          groupid: chartIdGroup[0],
          details: {
            AnalysePage: [],
            MapsPage: [],
          },
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Dashboard créé");
        } else {
          NotificationManager.error("Une erreur est survenue");
        }
        refreshTable();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  useEffect(() => {
    setPage('vues');
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      axios
        .get(getUsers(chartIdGroup), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setDashboardList(res.data.views);
          if (value == 0 && res.data.views.length > 0) {
            setValue(res.data.views[0].id);
          }
        });
    }
  }, [refresh, chartIdGroup]);

  const refreshTable = () => {
    setRefresh(!refresh);
  };

  return (
    <div
      style={{
        padding: "0.5rem",
      }}
    >
      <div className={classes.root}>
        <div>
          {permis.includes("view_create") ? (
            <AddDashboard handleNewDashboard={handleNewDashboard} />
          ) : (
            <></>
          )}

          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleTabChange}
            aria-label="Vertical tabs example"
            className={classes.tabs}
            TabIndicatorProps={{ style: { background: "#91C73C" } }}
          >
            {dashboardList.map(({ id, name }) => (
              <Tab
                key={id}
                className={classes.tab}
                label={name}
                value={id}
                {...a11yProps(id)}
              />
            ))}
          </Tabs>
        </div>
        {dashboardList.map(({ id, name }, index) => (
          <TabPanel key={id} value={value} index={id}>
            <TabDetail id={id} fetchData={refreshTable} />
          </TabPanel>
        ))}
      </div>
    </div>
  );
}
